import React from "react";
import { FilterTypeSelection } from "./BasicInformationPage/FilterTypeSelection";
import { FormValues, BulkMessageSendFilterType } from "./types";
import { useFormContext } from "react-hook-form";
import { RiseActionStudents } from "./RiseActionStudents";

interface RiseActionSendProps {
  filterType: BulkMessageSendFilterType;
  setFilterType: React.Dispatch<
    React.SetStateAction<BulkMessageSendFilterType>
  >;
}
export function RiseActionSend({
  filterType,
  setFilterType,
}: RiseActionSendProps) {
  const { getValues } = useFormContext<FormValues>();
  const riseActionId = getValues("filters.riseActionId");

  return (
    <div className="flex flex-col">
      <FilterTypeSelection
        filterType={filterType}
        setFilterType={setFilterType}
        disabled={true}
      />
      <div className="flex flex-col gap-4 px-6 pt-3 pb-6">
        <RiseActionStudents actionId={riseActionId} />
      </div>
    </div>
  );
}
